import script from "./managementOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./managementOrder.vue?vue&type=script&setup=true&lang=js"

import "./managementOrder.vue?vue&type=style&index=0&id=08df9ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08df9ffc"]])

export default __exports__